<template>
  <div class="flex justify-center" aria-busy="true">
    <div
      class="animate-spin h-10 w-10 border-4 border-blue-500 rounded-full border-t-transparent"
    />
  </div>
</template>
